import { api } from './authService';

/**
 * Fire-and-forget: ask the backend to start the Databricks SQL warehouse so it is
 * warm before the user runs a Segments count or Query lookup.
 */
export function wakeSqlWarehouse() {
  api.post('/api/v2/sql-warehouse/start').catch((err) => {
    console.warn('SQL warehouse wake failed:', err?.response?.data?.detail || err.message || err);
  });
}
